import { getFormValues } from "redux-form";

import { F } from "../../../../../constants";

export const getShippingDefaultsFormValues = getFormValues(
  F.FORMS_NAMES.SHIPPING_DEFAULTS_FORM
);
